import 'arrive';

document.arrive('.component-pop-up-newsletter', { existing: true }, function () {
    const popup = document.getElementById('component-pop-up-newsletter');
    if (!popup) return;

    const closeBtn = popup.querySelector('.icon-close');
    const cookieName = 'hb_newsletter_popup_closed';
    const cookieDurationDays = 1;

    // --- Cookie helper ---
    function setCookie(name, value, days) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
    }

    function getCookie(name) {
        return document.cookie.split('; ').find(row => row.startsWith(name + '='))?.split('=')[1];
    }

    // --- Funzione per mostrare popup ---
    function showPopup(force = false) {
        if (!force && getCookie(cookieName)) return;
        popup.classList.add('is-visible');
        popup.setAttribute('aria-hidden', 'false');
    }

    // --- Funzione per nascondere popup ---
    function hidePopup() {
        popup.classList.remove('is-visible');
        popup.setAttribute('aria-hidden', 'true');
        setCookie(cookieName, 'true', cookieDurationDays);
    }

    closeBtn?.addEventListener('click', hidePopup);

    // --- Logica popup custom ---
    const customPopups = document.querySelectorAll('.component-custom-popups .custom-popup');

    const allCustomClosed = () => {
        if (!customPopups.length) return true;
        return Array.from(customPopups).every(p => {
            const pCookie = p.dataset.cookieName;
            return document.cookie.includes(`${pCookie}=true`);
        });
    };

    const initNewsletterPopup = () => {
        if (!getCookie(cookieName)) {
            setTimeout(() => showPopup(false), 10000);
        }
    };

    if (allCustomClosed()) {
        initNewsletterPopup();
    } else {
        const observer = new MutationObserver(() => {
            if (allCustomClosed()) {
                initNewsletterPopup();
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    // --- Fake placeholder ---
    const formWrapper = popup.querySelector('.component-pop-up-newsletter__form-wrapper');
    const fakePlaceholder = formWrapper?.querySelector('.fake-placeholder');
    const input = formWrapper?.querySelector('input');

    if (formWrapper && fakePlaceholder && input) {
        formWrapper.addEventListener('click', (e) => {
            if (!e.target.closest('.fake-placeholder a')) {
                fakePlaceholder.style.display = 'none';
                input.focus();
            }
        });

        input.addEventListener('blur', () => {
            if (!input.value.trim()) {
                fakePlaceholder.style.display = '';
            }
        });
    }

    // --- Toggle XL ---
    const intro = popup.querySelector('.component-pop-up-newsletter__intro');
    if (intro && formWrapper) {
        intro.addEventListener('click', () => {
            if (window.innerWidth < 1200) {
                formWrapper.classList.toggle('is-visible');
            }
        });

        window.addEventListener('resize', () => {
            if (window.innerWidth >= 1200) {
                formWrapper.classList.remove('is-visible');
            }
        });
    }

    // --- Attivatore manuale ---
    document.addEventListener('click', (e) => {
        if (e.target.closest('.activate-form-pop-up')) {
            e.preventDefault();
            showPopup(true);
        }
    });

    // --- Nascondi/Mostra quando footer visibile ---
    const footer = document.querySelector('footer');
    if (footer) {
        let autoHiddenByFooter = false;

        const handleFooterVisibility = () => {
            const rect = footer.getBoundingClientRect();
            const inView = rect.top < window.innerHeight && rect.bottom > 0;

            if (inView) {
                if (popup.classList.contains('is-visible')) {
                    popup.classList.remove('is-visible');
                    popup.setAttribute('aria-hidden', 'true');
                    autoHiddenByFooter = true;
                }
            } else {
                if (autoHiddenByFooter) {
                    showPopup(false);
                    autoHiddenByFooter = false;
                }
            }
        };

        if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting || entry.intersectionRatio === 0) {
                        handleFooterVisibility();
                    }
                });
            }, { root: null, threshold: [0] });
            io.observe(footer);
        } else {
            const onScrollResize = () => handleFooterVisibility();
            window.addEventListener('scroll', onScrollResize, { passive: true });
            window.addEventListener('resize', onScrollResize);
        }
    }
});
